// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_LIST_OF_GROUPS = "Sp\u00e4\u0165 na zoznam skup\u00edn";
export const GROUP_FIND_SOME_IN_A_LIST_OF_GROUPS_AND_FORUMS = "N\u00e1jdi si nejak\u00fa v <0>Zozname skup\u00edn a diskusi\u00ed</0> :-)";
export const GROUP_LIST = "Zoznam skup\u00edn";
export const RECENT_COMMENTS = "Najnov\u0161ie koment\u00e1re";
export const RECENT_POSTS = "Najnov\u0161ie pr\u00edspevky";
export const YOU_ARE_NOT_IN_ANY_GROUP_SO_FAR = "Zatia\u013e nie si v \u017eiadnej skupine";
